module.exports = __webpack_public_path__ + "img/map-marker.9420bed6.svg";